import { ApiBankLists, APIgetmemberWithdrawWallet, ApigetGuadanEnum, ApigetGuadanTxEnum, ApiWrgdRechargeConfig, ApiWrgdWithdrawConfig } from '@api/service'

export default {
  namespaced: true,
  state: {
    bindedBankList: [],
    bindedWWList: [],
    type: 'pay',
    depositRemark: "", // 充值备注
    currencyType: {},
    guadanTxEnum: {},//挂单提现状态集合
    guadanCzEnum: {},//挂单充值状态集合
    guadanCzClConfig: null,//挂单充值策略配置
    guadanTxClConfig: null,//挂单提现策略配置
    balanceIsHide: false


  },
  mutations: {

    setcurrencyType(state, val) {
      state.currencyType = {
        'TWD': {
          icon: ' NT$',
          name: '新台币',
          type: 'TWD'
        },
        'THB': {
          icon: ' NT$',
          name: '泰币',
          type: 'THB'
        },
        'CNY': {
          icon: ' ¥',
          name: '人民币',
          type: 'CNY'
        },
        'USDT': {
          icon: '₮',
          name: '泰达币',
          type: 'USDT'
        },
      }
    },
    setbindedBankList(state, payload) {
      state.bindedBankList = [...payload]
    },
    setbindedWWList(state, payload) {
      state.bindedWWList = [...payload]
    },
    setDepositRemark(state, payload) {
      state.depositRemark = payload
    },
    setGuadanTxEnum(state, payload) {
      state.guadanTxEnum = payload
    },
    setGuadanCzEnum(state, payload) {
      state.guadanCzEnum = payload
    },
    setGuadanCzClConfig(state, payload) {
      state.guadanCzClConfig = payload
    },
    setGuadanTxClConfig(state, payload) {
      state.guadanTxClConfig = payload
    },
    setBalanceIsHide(state, payload) {
      state.balanceIsHide = payload
    }

  },
  actions: {
    getbindedBankList({ state, commit, dispatch }) {

      return new Promise((resolve, reject) => {
        ApiBankLists({}).then((res) => {
          if (res.code == '12200') {
            let t = res.data
            t = t.map(item => {
              item.bankcardNo = `${item.bankcardNo.slice(0, 4)} **** **** ${item.bankcardNo.slice(-4)}`
              return item;
            })
            commit('setbindedBankList', t)
          }
          resolve(res)
        })
      })
    },
    getbindedWWList({ state, commit, dispatch }) {

      return new Promise((resolve, reject) => {
        APIgetmemberWithdrawWallet({}).then((res) => {
          if (res.code == '12200') {
            let t = res.data.map(item => {
              if (item.receiveAddress.length > 8) {
                item.receiveAddress = `${item.receiveAddress.slice(0, 4)} **** **** ${item.receiveAddress.slice(-4)}`
              }
              return item;
            })
            commit('setbindedWWList', t)
          }
          resolve(res)
        })
      })
    },
    async getGuadanTxEnum({ state, commit, dispatch }) {
      let res = await ApigetGuadanTxEnum()
      if (res.code == '12200') {
        commit('setGuadanTxEnum', res.data)
      }
    },
    async getGuadanCzEnum({ state, commit, dispatch }) {
      let res = await ApigetGuadanEnum()
      if (res.code == '12200') {
        commit('setGuadanCzEnum', res.data)
      }
    },
    async getGuadanCzClConfig({ state, commit, dispatch }) {
      let res = await ApiWrgdRechargeConfig()
      if (res.code == '12200') {
        commit('setGuadanCzClConfig', res.data || null)
      }
    },
    async getGuadanTxClConfig({ state, commit, dispatch }) {
      let res = await ApiWrgdWithdrawConfig()
      if (res.code == '12200') {
        commit('setGuadanTxClConfig', res.data || null)
      }
    },

  }
}
